<template>
  <div class="answer">
    <ul class="items">
      <li class="item">
        <div class="item__inner" v-on:click="selectItem('yes')" :class="{isSelected:isSelectedYes}">
          <img :src="`${staticPath}img/factory/test/answer_yes.png`">
        </div>
      </li>
      <li class="item">
        <div class="item__inner" v-on:click="selectItem('no')" :class="{isSelected:isSelectedNo}">
          <img :src="`${staticPath}img/factory/test/answer_no.png`">
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/modules.scss';

  .items {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding-top: 10px;
    max-width: 340px;
  }

  .item {
    width: calc(50% - 10px);
  }

  .item__inner {
    position: relative;
    width: 150px;
    height: 150px;
    margin: 0 auto;
    padding: 25px;
    background-color: #fff;
    border-radius: 10px;

    @include mq_sp_s {
      width: 125px;
      height: 125px;
    }

    &.isSelected {
      transform: translateY(10px);
    }
  }
</style>

<script>
  import Constant from '@/constant';

  export default {
    name: 'AnswerYesNo',
    props: ['correctId'],

    data(){
      return {
        staticPath: Constant.STATICPATH,
        isSelectedYes: false,
        isSelectedNo: false,
        choiceId: 0,
      }
    },

    methods: {

      selectItem(item_type){

        if (item_type == 'yes') {

          this.isSelectedYes = true;
          this.choiceId = 1;
        
        } else if (item_type == 'no') {

          this.isSelectedNo = true;
          this.choiceId = 2;
        }

        this.checkAnswer();
      },

      checkAnswer() {

        if (this.correctId == this.choiceId) {
          // 正解
          this.$emit('check-answer', true);
        } else {
          // 不正解
          this.$emit('check-answer', false);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Study/Parts/AnswerYesNo.vue